jQuery(function($) {

  window.articleArchive = {}

  window.articleArchive.more = function() {

    let $this = $(this)

    $this
      .attr('disabled', 'disabled')
      .addClass('loading')

    $.get( $this.data('url'), function( data, status ) {
      content = $( $.parseHTML( data ) ).find('#articles').html()
      $this
        .parent()
        .replaceWith( content )

      window.articleArchive.observer()
    })
  }

  window.articleArchive.observerCallback = function(entries, observer) {
      entries.forEach(entry => {
          if (entry.isIntersecting) {
              let $group = $(entry.target)
              let title = $('title').html()

              window.history.pushState({ state: $group.data('paged') }, title, url.current + '/page/' + $group.data('paged') + '/')
          }
      })
  }

  window.articleArchive.observer = function() {
      if ('IntersectionObserver' in window) {
          let groups = document.querySelectorAll('.article-group')
          let object = new IntersectionObserver(
              window.articleArchive.observerCallback, {
                  threshold: 0
              }
          )
          for (const group of groups) {
              object.observe(group)
          }
      }
  }

  window.articleArchive.eventListeners = function() {
      window.articleArchive.observer()
      $('body').on('click', '.more-articles', window.articleArchive.more)
  }

  window.articleArchive.eventListeners()
})


// WEBPACK FOOTER //
// ./src/js/article-archive.js